const fontSizes = {
  XS: '0.7rem',
  S: '0.9rem',
  M: '1rem',
  L: '1.2rem',
  XL: '1.5rem',
  XXL: '2rem',
  XXXL: '3rem',
};

export default fontSizes;
